// テーマの下書き本文を自動保存する
module.exports.OfferDescriptionDraft = App.Views.Base.extend({
  el: '.js-offer-description',
  events: {
    keyup: 'save'
  },
  draftKey: 'offerDraft',
  save: function(event) {
    var draft = {
      text : $(event.currentTarget).val(),
      modified : Date.now() / 1000,
    };
    localStorage.setItem(this.draftKey, JSON.stringify(draft));
    var $modifiedFlash = $('.js-offer-draft-modified');
    var modified = new Date();
    $modifiedFlash.text(modified.getHours() + '時' + modified.getMinutes() + '分'  + modified.getSeconds() +'秒に下書きが保存されました');
  },
  load: function() {
    var draft = localStorage.getItem(this.draftKey);
    if (! draft) {
      return;
    }
    draft = JSON.parse(draft);
    var lastModified = new Date(draft.modified * 1000);
    let confirmMessage = (lastModified.getMonth() + 1) + '月' + lastModified.getDate() + '日';
    confirmMessage += lastModified.getHours() +'時' + lastModified.getMinutes() + '分';
    confirmMessage += 'に書きかけの説明文があります。読み込みますか?';
    if (! confirm(confirmMessage)) {
      return;
    }
    this.$el.val(draft.text);
  },
  clear: function() {
    localStorage.removeItem(this.draftKey);
  }
});

// テーマの公開設定
module.exports.PublishOfferLink = App.Views.Base.extend({
  el: '.js-update-offer-visibility',
  events: {
    'click': 'togglePublish'
  },
  submitOfferEdit: function(id, flag) {
    $('<form/>', {
      action: '/admin/offer/edit/' + id,
      method: 'post'
    }).append($('<input/>', {
      type: 'hidden',
      name: 'data[Offer][is_open]',
      value: flag
    })).append($('<input/>', {
      type: 'hidden',
      name: 'data[token]',
      value: App.me.token
    })).submit();
  },
  togglePublish: function(event) {
    var $el = $(event.currentTarget);
    var isPublish = $el.hasClass('js-publish');
    if (confirm((isPublish ? '公開' : '非公開に') + 'します。よろしいですか？')) {
      this.submitOfferEdit(
        $el.data('offerId'),
        isPublish ? '1' : '0'
      );
    }
  }
});

module.exports.OfferAssignUserList = App.Views.Base.extend({
  el: '.js-offer-assign-user-list',
  events: {
    'click .js-remove-offer-user': 'removeUser'
  },
  assignUsers: null,
  initialize: function() {
    this.assignUsers = [];
    this.render();
  },
  render: function() {
    if (this.assignUsers.length < 1) {
      // 1件もない
      var li = $('<li/>', {
        addClass: 'p-sprt-theme-assign-user__list'
      });
      var id = $('<div/>', {
        addClass: 'p-sprt-theme-assign-user__list__name-wrapper'
      }).append($('<span/>', {
        addClass: 'p-sprt-theme-assign-user__list__name',
        text: 'アサインされているライターはいません'
      }));
      this.$el.html(li.append(id));
      return this;
    }

    var html = [];
    _.each(this.assignUsers, function(val) {
      var li = $('<li/>', {
        addClass: 'p-sprt-theme-assign-user__list'
      });

      // idの表示部分
      var id = $('<div/>', {
        addClass: 'p-sprt-theme-assign-user__list__name-wrapper'
      }).append($('<span/>', {
        addClass: 'p-sprt-theme-assign-user__list__name',
        text: val
      }));

      // 取り消しボタン
      var cancel = $('<div/>', {
        addClass: 'p-sprt-theme-assign-user__list__edit-wrapper'
      }).append($('<a/>', {
        addClass: 'p-sprt-theme-assign-user__list__edit c-sprt-btn-sm c-sprt-btn--primary-o js-remove-offer-user',
        href: 'javascript://',
        text: '取消'
      }).data('userId', val));
      html.push(li.append(id, cancel));
    });
    this.$el.html(html);
    return this;
  },
  addUser: function(id) {
    this.assignUsers.push(id);
    this.render();
  },
  removeUser: function(event) {
    this.assignUsers.splice(this.assignUsers.indexOf($(event.currentTarget).data('userId')), 1);
    this.render();
  },
  contains: function(id) {
    return this.assignUsers.indexOf(id) >= 0;
  },
  toString: function() {
    return this.assignUsers.join(',');
  }
});



// WEBPACK FOOTER //
// ./view/offer.js